import React from 'react';
export function OpportunitySection() {
  return <section className="py-16 px-4 bg-brand-card/50 border-y border-white/5" data-id="element-183">
      <div className="max-w-3xl mx-auto" data-id="element-184">
        <div className="text-center mb-10" data-id="element-185">
          <span className="text-5xl mb-4 block" data-id="element-186">💡</span>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-187">
            El problema no es el italiano… es el modelo
          </h2>
        </div>

        <div className="text-center mb-10" data-id="element-188">
          <p className="text-2xl font-bold text-brand-gold mb-8" data-id="element-189">
            No necesitas más alumnos.
          </p>
          <p className="text-xl text-gray-200 mb-6" data-id="element-190">
            Necesitas un sistema que te permita:
          </p>
        </div>

        <div className="grid gap-4 mb-12" data-id="element-191">
          {['Escalar tu conocimiento', 'Llegar a más personas sin trabajar más', 'Generar ingresos incluso cuando no estás dando clases'].map((item, i) => <div key={i} className="bg-brand-dark p-6 rounded-xl border border-brand-gold/20 flex items-center" data-id="element-192">
              <div className="bg-brand-gold/20 p-2 rounded-full mr-4" data-id="element-193">
                <svg className="w-6 h-6 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-194">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-195" />
                </svg>
              </div>
              <span className="text-lg text-white font-medium" data-id="element-196">{item}</span>
            </div>)}
        </div>

        <div className="text-center bg-gradient-to-r from-brand-gold/10 via-brand-gold/5 to-brand-gold/10 p-8 rounded-2xl border border-brand-gold/20" data-id="element-197">
          <p className="text-xl md:text-2xl text-white font-serif italic" data-id="element-198">
            Hoy, enseñar italiano ya no es solo dar clases… Es crear activos
            digitales que trabajan por ti.
          </p>
        </div>
      </div>
    </section>;
}